var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var clearFix = function () { return ({
    ':before': {
        content: '" "',
        display: 'table',
    },
    ':after': {
        content: '" "',
        display: 'table',
        clear: 'both',
    },
}); };
var icon = {
    dismiss: "data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='utf-8'?%3e%3c!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 128 128' style='enable-background:new 0 0 128 128;' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:XXXXX;%7d %3c/style%3e%3ctitle%3ebold/x-bold%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cpath class='st0' d='M74.6,63.3L117,20.9c0.8-0.8,0.8-2,0-2.8l-8.5-8.5c-0.8-0.8-2-0.8-2.8,0L63.3,52L21.6,10.3 c-0.8-0.8-2-0.8-2.8,0l-8.5,8.5c-0.8,0.8-0.8,2,0,2.8L52,63.3L9.6,105.7c-0.8,0.8-0.8,2,0,2.8L18,117c0.8,0.8,2,0.8,2.8,0l42.4-42.4 l43.1,43.1c0.8,0.8,2,0.8,2.8,0l8.5-8.5c0.8-0.8,0.8-2,0-2.8L74.6,63.3z'/%3e%3c/svg%3e",
    // eslint-disable-next-line quotes
    error: "data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='utf-8'?%3e%3c!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 128 128' style='enable-background:new 0 0 128 128;' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:XXXXX;%7d %3c/style%3e%3ctitle%3ebold/exclamation-circle-bold%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cpath id='Combined-Shape' class='st0' d='M109.2,18.8C96.1,6.2,81,0,64,0S31.9,6.2,18.8,18.8C6.2,31.9,0,47,0,64s6.2,32.1,18.8,45.2 C31.9,121.8,47,128,64,128s32.1-6.2,45.2-18.8C121.8,96.1,128,81,128,64S121.8,31.9,109.2,18.8z M64.5,21c2.3,0,4.2,0.7,5.8,2 s2.2,3,2.2,5c0,0.7-0.1,1.8-0.2,3.5L70.3,81c0,1.1-1,2-2.1,2h-6.5c-1.1,0-2.1-0.9-2.1-2l-3.4-49c-0.2-1.5-0.2-2.4-0.2-2.8 c0-2.8,0.7-4.9,2.2-6.2C59.6,21.7,61.7,21,64.5,21z M70.2,104c-1.7,1.5-3.6,2.2-5.9,2.2c-2.3,0-4.2-0.8-5.9-2.4s-2.5-3.6-2.5-6 s0.7-4.3,2.2-5.6c1.8-1.7,3.9-2.5,6.1-2.5c2.3,0,4.2,0.8,5.8,2.4s2.4,3.5,2.4,5.9S71.8,102.3,70.2,104z'/%3e%3c/svg%3e",
    // eslint-disable-next-line quotes
    info: "data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='utf-8'?%3e%3c!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 128 128' style='enable-background:new 0 0 128 128;' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:XXXXX;%7d %3c/style%3e%3ctitle%3ebold/info-circle-bold%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cpath id='Shape' class='st0' d='M109.2,18.8C96.1,6.2,81,0,64,0S31.9,6.2,18.8,18.8C6.2,31.9,0,47,0,64s6.2,32.1,18.8,45.2 C31.9,121.8,47,128,64,128s32.1-6.2,45.2-18.8C121.8,96.1,128,81,128,64S121.8,31.9,109.2,18.8z M64.5,23.8c3.3,0.2,6.1,1.4,8.4,3.6 s3.4,5.1,3.4,8.5s-1.1,6.2-3.4,8.5s-5.1,3.4-8.5,3.4c-3.4,0-6.2-1.1-8.5-3.4s-3.4-5.1-3.4-8.5s1.1-6.2,3.4-8.5S61,23.9,64.5,23.8z M84.5,91.2c0,0.6-0.2,1.4-0.5,1.8c0,0-1,1.9-5.3,5.3S69,104,61,104c-4,0-7.8-1.1-10-3s-3.5-4.8-2.8-8.8C50,83,54.5,65,54.5,65 c0.3-2.5-0.7-4.1-3-4.8l-4.3-1c-0.5-0.1-1-0.7-1-1.2v-1c0-0.6,0.5-1,1-1H71c1,0,1.8,0.4,2.4,1.2s0.7,1.7,0.4,2.8c0,0-4.8,22-5.8,26 c-1.5,5.8,0.8,7.8,4,7.8c4-0.2,7.1-1.1,9.2-2.8s2.5-2.1,2.5-2.1c0.4-0.4,0.7-0.2,0.7,0.3V91.2z'/%3e%3c/svg%3e",
    // eslint-disable-next-line quotes
    neutral: "data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='utf-8'?%3e%3c!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 128 128' style='enable-background:new 0 0 128 128;' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:XXXXX;%7d %3c/style%3e%3ctitle%3ebold/info-circle-bold%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cpath id='Shape' class='st0' d='M109.2,18.8C96.1,6.2,81,0,64,0S31.9,6.2,18.8,18.8C6.2,31.9,0,47,0,64s6.2,32.1,18.8,45.2 C31.9,121.8,47,128,64,128s32.1-6.2,45.2-18.8C121.8,96.1,128,81,128,64S121.8,31.9,109.2,18.8z M64.5,23.8c3.3,0.2,6.1,1.4,8.4,3.6 s3.4,5.1,3.4,8.5s-1.1,6.2-3.4,8.5s-5.1,3.4-8.5,3.4c-3.4,0-6.2-1.1-8.5-3.4s-3.4-5.1-3.4-8.5s1.1-6.2,3.4-8.5S61,23.9,64.5,23.8z M84.5,91.2c0,0.6-0.2,1.4-0.5,1.8c0,0-1,1.9-5.3,5.3S69,104,61,104c-4,0-7.8-1.1-10-3s-3.5-4.8-2.8-8.8C50,83,54.5,65,54.5,65 c0.3-2.5-0.7-4.1-3-4.8l-4.3-1c-0.5-0.1-1-0.7-1-1.2v-1c0-0.6,0.5-1,1-1H71c1,0,1.8,0.4,2.4,1.2s0.7,1.7,0.4,2.8c0,0-4.8,22-5.8,26 c-1.5,5.8,0.8,7.8,4,7.8c4-0.2,7.1-1.1,9.2-2.8s2.5-2.1,2.5-2.1c0.4-0.4,0.7-0.2,0.7,0.3V91.2z'/%3e%3c/svg%3e",
    // eslint-disable-next-line quotes
    pending: "data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='utf-8'?%3e%3c!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1 Tiny//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11-tiny.dtd'%3e%3csvg version='1.1' baseProfile='tiny' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 16 16' xml:space='preserve'%3e%3cpath fill='XXXXX' d='M8,0C3.581,0,0,3.583,0,8c0,4.424,3.581,8,8,8c4.416,0,8-3.576,8-8C16,3.583,12.416,0,8,0z M13.185,9.846 H6.628V3.204h1v5.643h5.557V9.846z'/%3e%3c/svg%3e",
    // eslint-disable-next-line quotes
    success: "data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='utf-8'?%3e%3c!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1 Tiny//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11-tiny.dtd'%3e%3csvg version='1.1' baseProfile='tiny' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 16 16' xml:space='preserve'%3e%3cpath fill='XXXXX' d='M8,0C3.581,0,0,3.583,0,8c0,4.424,3.581,8,8,8c4.416,0,8-3.576,8-8C16,3.583,12.416,0,8,0z M7.504,11.89 L3.491,9.169l0.561-0.828l3.184,2.158l4.242-6.31l0.83,0.558L7.504,11.89z'/%3e%3c/svg%3e",
    // eslint-disable-next-line quotes
    warning: "data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='utf-8'?%3e%3c!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 128 128' style='enable-background:new 0 0 128 128;' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:XXXXX;%7d %3c/style%3e%3ctitle%3ebold/exclamation-triangle-bold%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cpath class='st0' d='M124.8,99.4L82.1,14.9c-10-19.7-26.1-19.7-36.1,0L3.2,99.4C-4.8,115.2,3,128,20.7,128h86.6 C125,128,132.8,115.2,124.8,99.4z M70.2,109c-1.7,1.5-3.6,2.2-5.9,2.2s-4.2-0.8-5.9-2.4c-1.7-1.6-2.5-3.6-2.5-6s0.8-4.3,2.2-5.6 c1.8-1.7,3.9-2.5,6.1-2.5s4.2,0.8,5.8,2.4c1.6,1.6,2.4,3.5,2.4,5.9C72.5,105.3,71.8,107.3,70.2,109z M72.2,36.5L70.3,86 c0,1.1-1,2-2.1,2h-6.5c-1.1,0-2.1-0.9-2.1-2l-3.4-49c-0.2-1.5-0.2-2.4-0.2-2.8c0-2.8,0.8-4.9,2.2-6.2c1.3-1.3,3.4-2,6.2-2 c2.3,0,4.2,0.7,5.8,2s2.2,3,2.2,5C72.5,33.7,72.4,34.8,72.2,36.5z'/%3e%3c/svg%3e",
};
var getIcon = function (icon, size, fill, label) {
    if (label === void 0) { label = undefined; }
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        label: label,
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        marginTop: '1px',
        width: size,
        height: size,
    };
};
export var dismissIcon = getIcon(icon.dismiss, 16, '#000000');
export var dismissIconWarning = getIcon(icon.dismiss, 16, '#000000');
export var neutralIcon = getIcon(icon.neutral, 20, '#2A3742');
export var errorIcon = getIcon(icon.error, 20, '#CC0821');
export var infoIcon = getIcon(icon.info, 20, '#003FB8');
export var pendingIcon = getIcon(icon.pending, 20, '#5E00A6');
export var successIcon = getIcon(icon.success, 20, '#007300');
export var warningIcon = getIcon(icon.warning, 20, '#E5A700');
var reset = {
    backgroundAttachment: 'scroll',
    backgroundClip: 'border-box',
    backgroundOrigin: 'padding-box',
    backgroundSize: 'auto',
    fontFamily: '"Open Sans", Helvetica, Arial, sans-serif',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '14px',
    textSizeAdjust: '100%',
};
export var callout = __assign(__assign(__assign({}, clearFix()), reset), { background: '#F2F5F7', color: '#000000', boxShadow: '0px 3px 6px 1px #323E4814', border: "1px solid ".concat('#2A3742'), borderRadius: 8, boxSizing: 'border-box', display: 'flex', overflow: 'hidden', padding: "".concat(8, "px ").concat(8, "px ").concat(8, "px ").concat(16, "px"), position: 'relative', width: '100%', marginBottom: 16, minHeight: '56px', '& button': {
        border: "1px solid ".concat('#1E2C38'),
        color: '#000000',
        fontWeight: '600',
        fontSize: 14,
        ':before': {
            display: 'none',
        },
        ':disabled': {
            background: 'none !important',
            border: "1px solid ".concat('#A8B2BA', " !important"),
            color: "".concat('#8E9AA3', " !important"),
        },
        ':focus': {
            background: 'none',
            outline: "1px solid #1E2C38",
            border: "1px solid transparent",
        },
        ':focus-visible': {
            '--box-shadow-color': 'none',
            outline: "1px solid #1E2C38",
            border: "1px solid transparent",
        },
        ':hover': {
            backgroundColor: '#A8B2BA',
            color: '#000000',
            '--button-hover-text-color': 'inherit',
        },
        ':active': {
            background: '#F2F5F7',
            color: "".concat('#000000', " !important"),
        },
    } });
export var calloutNeutral = callout;
export var calloutError = __assign(__assign({}, callout), { background: '#FFEBED', border: "1px solid ".concat('#CC0821'), '& button': __assign(__assign({}, callout['& button']), { ':focus': __assign({}, callout['& button'][':focus']), ':hover': __assign(__assign({}, callout['& button'][':hover']), { backgroundColor: '#F0A3AD' }), ':active': {
            background: '#FFEBED',
            color: "".concat('#000000', " !important"),
        } }) });
export var calloutWarning = __assign(__assign({}, callout), { background: '#FFF6DE', border: "1px solid ".concat('#E5A700'), '& button': __assign(__assign({}, callout['& button']), { ':focus': __assign({}, callout['& button'][':focus']), ':hover': __assign(__assign({}, callout['& button'][':hover']), { backgroundColor: '#FFE8AB' }), ':active': {
            background: '#FFF6DE',
            color: "".concat('#000000', " !important"),
        } }) });
export var calloutPending = __assign(__assign({}, callout), { background: '#F5E5FF', border: "1px solid ".concat('#5E00A6'), '& button': __assign(__assign({}, callout['& button']), { ':focus': __assign({}, callout['& button'][':focus']), ':hover': __assign(__assign({}, callout['& button'][':hover']), { backgroundColor: '#DEB2FF' }), ':active': {
            background: '#F5E5FF',
            color: "".concat('#000000', " !important"),
        } }) });
export var calloutInformation = __assign(__assign({}, callout), { background: '#E5EFFF', border: "1px solid ".concat('#003FB8'), '& button': __assign(__assign({}, callout['& button']), { ':focus': __assign({}, callout['& button'][':focus']), ':hover': __assign(__assign({}, callout['& button'][':hover']), { backgroundColor: '#80ACFF' }), ':active': {
            background: '#E5EFFF',
            color: "".concat('#000000', " !important"),
        } }) });
export var calloutSuccess = __assign(__assign({}, callout), { background: '#E5FFE5', border: "1px solid ".concat('#007300'), '& button': __assign(__assign({}, callout['& button']), { ':focus': __assign({}, callout['& button'][':focus']), ':hover': __assign(__assign({}, callout['& button'][':hover']), { backgroundColor: '#82D982' }), ':active': {
            background: '#E5FFE5',
            color: "".concat('#000000', " !important"),
        } }) });
export var iconContainer = {
    display: 'flex',
    marginRight: 12,
    marginTop: 8,
};
export var contentWrapper = {
    display: 'flex',
    flexGrow: 1,
};
export var contentWrapperWithTitle = {
    flexDirection: 'column',
    marginBottom: 5,
    marginTop: 8,
};
export var message = {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    color: '#000000',
    marginTop: 8,
    marginRight: 32,
    '& p': {
        fontSize: 16,
        lineHeight: "".concat('24', "px"),
        fontWeight: 600,
    },
};
export var messageWithTitle = {};
export var title = {
    color: '#000000',
    display: 'flex',
    fontSize: 16,
    fontWeight: 800,
    lineHeight: "".concat('24', "px"),
    marginTop: -9,
    paddingRight: 12,
};
export var actions = {
    display: 'flex',
    alignSelf: 'flex-end',
    marginBottom: 6,
};
export var actionsWithTitle = {
    alignSelf: 'flex-start',
    marginTop: 12,
    marginBottom: 0,
};
export var dismissButton = {
    border: 'none !important',
    borderRadius: '50%',
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    height: 32,
    width: 32,
    '&:first-of-type': {
        marginLeft: "".concat(24, "px !important"),
        marginTop: 4,
        marginRight: 4,
    },
    '&:focus, &:focus-visible': {
        color: 'inherit',
        boxShadow: 'unset !important',
        '--box-shadow-color': 'unset',
    },
    '&:hover': {
        boxShadow: 'none',
    },
    '&:active': {
        boxShadow: 'none',
    },
    '& i': {
        marginTop: 4,
    },
};
